import { useState, useEffect, useCallback } from 'react'

type PermissionState = NotificationPermission | 'unsupported' | 'ios-browser'

function detectPermissionState(): PermissionState {
  if (typeof Notification !== 'undefined') return Notification.permission
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return 'unsupported'
  const ua = navigator.userAgent || ''
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as unknown as { MSStream?: unknown }).MSStream
  if (!isIOS) return 'unsupported'
  const isStandalone =
    window.matchMedia?.('(display-mode: standalone)').matches === true ||
    (navigator as unknown as { standalone?: boolean }).standalone === true
  return isStandalone ? 'unsupported' : 'ios-browser'
}

export function usePushPermission() {
  const [permission, setPermission] = useState<PermissionState>(() => detectPermissionState())

  useEffect(() => {
    const interval = setInterval(() => {
      setPermission(detectPermissionState())
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const requestPermission = useCallback(async (): Promise<NotificationPermission> => {
    if (typeof Notification === 'undefined') return 'denied'
    const result = await Notification.requestPermission()
    setPermission(result)
    return result
  }, [])

  return { permission, requestPermission }
}
